import React, { useState } from 'react';
import { i18n } from 'config/locales';
import { Modal } from 'components/Modal';
import classnames from 'classnames';
import env from 'config/environment';

interface SurveyProps {
  className?: string
  initialShow?: boolean
  surveyText?: string
  showButton?: boolean
}

const Survey: React.FC<SurveyProps> = function (props: SurveyProps) {
  const {
    initialShow = false, surveyText = 'survey.contents', showButton = true,
  } = props;
  const [show, setShow] = useState(initialShow);
  const toggleModalIsOpen = (v: boolean) => {
    setShow(v);
  };
  const setModalIsOpenTrue = () => {
    setShow(true);
  };

  const onDismiss = () => toggleModalIsOpen(false);

  const getSurveyUrl = () => {
    const defaultSetting = '__SURVEY_URL__';
    let result = env.SurveyUrl();
    if (result === defaultSetting) {
      result = 'https://touchpoints.app.cloud.gov/touchpoints/6be9ec2d';
    }
    if (result.toUpperCase() === 'DISABLE' || result === 'DISABLED' || result === 'FALSE') {
      result = '';
    }
    return result;
  };

  // This is gated behind isLoading to allow the Loading Modal to take
  // priority when it is on the screen.
  return (
    <>
      {showButton && (
        <button
          type="button"
          className={classnames(props.className, 'survey-link')}
          style={{ fontWeight: 700, display: 'inline' }}
          onClick={setModalIsOpenTrue}
        >
          {i18n.t('survey.link.text')}
        </button>
      )}
      <Modal
        show={show}
        className="survey-modal"
        onDismiss={onDismiss}
        closeable
      >
        <div className="survey-text">
          {i18n.m2(surveyText)}
          <div>
            <a
              href={getSurveyUrl()}
              target="_blank"
              rel="noopener noreferrer"
              className="mobile-hidden"
              style={{ fontWeight: 700 }}
              type="button"
            >
              {i18n.t('survey.button.text')}
            </a>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Survey;
